export default function Footer() {
  return (
    <footer className="bg-background-800 text-foreground-100">
      <div className="mx-auto w-full max-w-6xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-4">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-book-2-fill text-lg"></i>
              </span>
              <span className="font-heading text-xl font-bold text-foreground-50">
                韩漫拾光
              </span>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-foreground-300">
              专注好看的韩漫推荐，帮你筛选评分高、口碑好的作品，避开烂尾雷区。
              人气与经典并存，好评多的韩漫都在这里，放心入坑。
            </p>
            <div className="mt-5 flex gap-3">
              <a
                href="#top"
                aria-label="微博"
                className="flex h-9 w-9 items-center justify-center rounded-md bg-background-700 text-foreground-200 transition-colors hover:bg-primary-600 hover:text-background-50"
              >
                <i className="ri-weibo-line"></i>
              </a>
              <a
                href="#top"
                aria-label="即刻"
                className="flex h-9 w-9 items-center justify-center rounded-md bg-background-700 text-foreground-200 transition-colors hover:bg-primary-600 hover:text-background-50"
              >
                <i className="ri-flashlight-line"></i>
              </a>
              <a
                href="#top"
                aria-label="小红书"
                className="flex h-9 w-9 items-center justify-center rounded-md bg-background-700 text-foreground-200 transition-colors hover:bg-primary-600 hover:text-background-50"
              >
                <i className="ri-quill-pen-line"></i>
              </a>
            </div>
          </div>

          <div>
            <h3 className="font-heading text-sm font-bold text-foreground-50">
              推荐栏目
            </h3>
            <ul className="mt-4 flex flex-col gap-2.5 text-sm">
              <li><a href="#featured" className="text-foreground-300 transition-colors hover:text-primary-300">编辑精选</a></li>
              <li><a href="#ranking" className="text-foreground-300 transition-colors hover:text-primary-300">高分榜单</a></li>
              <li><a href="#list" className="text-foreground-300 transition-colors hover:text-primary-300">分类推荐</a></li>
              <li><a href="#guide" className="text-foreground-300 transition-colors hover:text-primary-300">挑漫指南</a></li>
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-sm font-bold text-foreground-50">
              阅读指引
            </h3>
            <ul className="mt-4 flex flex-col gap-2.5 text-sm">
              <li><a href="#voices" className="text-foreground-300 transition-colors hover:text-primary-300">读者口碑</a></li>
              <li><a href="#faq" className="text-foreground-300 transition-colors hover:text-primary-300">常见问题</a></li>
              <li><a href="#top" className="text-foreground-300 transition-colors hover:text-primary-300">回到顶部</a></li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-2 border-t border-background-700 pt-6 text-xs text-foreground-400 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 韩漫拾光 · 好看的韩漫推荐站，仅做评分与推荐参考。</p>
          <p>作品版权归原作者及官方平台所有，请支持正版阅读。</p>
        </div>
      </div>
    </footer>
  );
}